import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
// ✅ Import del logo local
import logoGavillero from "@/assets/images/logo/gavillero-logo.png";

export default function Footer() {
  return (
    <footer className="bg-neutral-950 text-neutral-400">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-6">
              <img
                src={logoGavillero}
                alt="Casa El Gavillero"
                className="h-10 w-10 rounded-full object-cover ring-1 ring-white/10"
              />
              <span className="font-serif-display text-xl text-white tracking-wide">
                Casa El Gavillero
              </span>
            </div>
            <p className="font-light text-sm leading-relaxed text-neutral-500 max-w-sm">
              Una propiedad de lujo boutique diseñada para ofrecer una experiencia
              memorable. Exclusividad, tranquilidad y elegancia en cada detalle.
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-serif-display text-white text-base mb-4 tracking-wide">Explorar</h4>
            <ul className="space-y-3 text-sm font-light">
              <li><a href="/#propiedad" className="hover:text-white transition-colors">La Propiedad</a></li>
              <li><a href="/#experiencias" className="hover:text-white transition-colors">Experiencias</a></li>
              <li><a href="/#galeria" className="hover:text-white transition-colors">Galería</a></li>
              <li><a href="/#eventos" className="hover:text-white transition-colors">Eventos</a></li>
              <li><Link to="/reservar" className="hover:text-white transition-colors">Reservar</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-serif-display text-white text-base mb-4 tracking-wide">Contacto</h4>
            <ul className="space-y-3 text-sm font-light">
              <li className="flex items-start gap-2">
                <MapPin size={15} className="mt-0.5 flex-shrink-0" />
                <span className="leading-relaxed">
                  Fresnos No.64 Colonia el Sauz,<br />
                  Tequisquiapan, Querétaro CP 76796
                </span>
              </li>
              <li className="flex items-center gap-2">
                <Phone size={15} className="flex-shrink-0" />
                <span>(414) 219 63 66</span>
              </li>
              <li className="flex items-center gap-2">
                <Phone size={15} className="flex-shrink-0" />
                <span>(427) 114 35 42</span>
              </li>
              <li className="flex items-center gap-2">
                <Mail size={15} className="flex-shrink-0" />
                <a href="mailto:reservaciones@casaelgavillero.com.mx" className="hover:text-white transition-colors">
                  reservaciones@casaelgavillero.com.mx
                </a>
              </li>
            </ul>
          </div>

          {/* Mapa */}
          <div>
            <h4 className="font-serif-display text-white text-base mb-4 tracking-wide">Ubicación</h4>
            <div className="w-full aspect-video rounded-sm overflow-hidden border border-white/10">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3735.6795160041283!2d-99.8870388!3d20.5602897!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d39dd35a874b3f%3A0x2457c28871df58cb!2sCasa%20el%20Gavillero!5e0!3m2!1ses!2smx!4v1786474751340!5m2!1ses!2smx"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="strict-origin-when-cross-origin"
                title="Ubicación de Casa El Gavillero"
                className="w-full h-full"
              />
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-16 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-neutral-600 font-light">
            © {new Date().getFullYear()} Casa El Gavillero. Todos los derechos reservados.
          </p>
          <div className="flex gap-6 text-xs text-neutral-600 font-light">
            <Link to="/aviso-privacidad" className="hover:text-neutral-400 transition-colors">
              Aviso de Privacidad
            </Link>
            <Link to="/terminos-condiciones" className="hover:text-neutral-400 transition-colors">
              Términos y Condiciones
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}